import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'sustainability',
  LABEL: 'Sustainability',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,273d8108-2059-455e-8e88-9c8e0ec48aab',
  PAGES_LIST_ID: 'a85e66a0-a97c-48ee-882e-bfee01314cb2',
  DOCUMENTS_LIST_ID: 'b2baa42d-ba2c-4be9-9d0b-67ff470cc2be',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuAiBPSdZIF5Fjoicjg7Eiqt-5FjDNUckSJt-mlG6Jgzx',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuAiBPSdZIF5Fjoicjg7EiqstpLqyLLrpS50LZ_9HDMK-',
  NEWS_TEMPLATE_ID: 'd63686a3-4b1d-46c1-80c5-725b583a7a2d',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  OPT_OUT_FILE_PATH: 'Settings/EmailOptOut.txt',
  MANAGER_ROLES: [ROLES.QSE_SUSTAINABILITY_MGR],
  VIVA_COMMUNITY_ID: undefined
}

export default config